import React from 'react';
export var SelectContext = React.createContext({ value: '', onSelect: function () { } });
//# sourceMappingURL=select-context.js.map